export default {"src":"/_next/static/media/email-hero-bg.1378883a.svg","height":405,"width":439,"blurWidth":0,"blurHeight":0};